export default __webpack_public_path__ + "static/media/1_template.9c4b9b87.svg";